import { getAuthToken, requestAuthAdmin } from './auth';
import { getSelectedEnvironment } from '../utils/apiEnvironment';

const ROOT = '/api-admin/v0/profile-interest-catalog';

export const profileInterestCatalogEnabled = process.env.REACT_APP_PROFILE_INTEREST_CATALOG_ADMIN_ENABLED === 'true';

export function assertCatalogEnvironment(environment) {
  if (!profileInterestCatalogEnabled) throw new Error('프로필 관심사 운영 API가 아직 연결되지 않았습니다.');
  if (!['test', 'prod'].includes(environment) || getSelectedEnvironment() !== environment) {
    throw new Error('대상 환경을 다시 선택하고 카탈로그를 재조회해 주세요.');
  }
}

async function requestCatalog(environment, path, options = {}) {
  assertCatalogEnvironment(environment);
  const token = getAuthToken();
  if (!token) throw new Error('관리자 로그인이 필요합니다.');
  const response = await requestAuthAdmin(`${ROOT}${path}`, options, token);
  const raw = await response.text();
  let body;
  try { body = JSON.parse(raw); } catch (_) { /* handled below */ }
  if (environment !== getSelectedEnvironment()) throw new Error('요청 중 환경이 변경됐습니다. 다시 조회해 주세요.');
  if (!response.ok) {
    const error = new Error(body?.data?.error || body?.data?.msg || body?.error || body?.message || body?.msg || `카탈로그 요청 실패 (${response.status})`);
    error.status = response.status;
    throw error;
  }
  // auth-admin ProxyOK wraps its `{data: providerResult}` in a response data field.
  const result = body?.data?.data || body?.data;
  if (!result || result.status !== 200) throw new Error('카탈로그 API 응답 형식이 맞지 않습니다.');
  return result;
}

export function readProfileInterestCatalog(environment, draftRevision) {
  const params = new URLSearchParams({ environment });
  if (draftRevision != null) params.set('draft_revision', String(draftRevision));
  return requestCatalog(environment, `?${params}`);
}

export function saveProfileInterestDraft(environment, { draftRevision, expectedEditRevision, catalog, actionId }) {
  return requestCatalog(environment, '/draft', {
    method: 'POST',
    body: JSON.stringify({ environment, action_id: actionId, draft_revision: draftRevision,
      expected_edit_revision: expectedEditRevision, catalog }),
  });
}

export function reviewProfileInterestDraft(environment, { draftRevision, expectedEditRevision, decision, actionId }) {
  return requestCatalog(environment, '/review', {
    method: 'POST',
    body: JSON.stringify({ environment, action_id: actionId, draft_revision: draftRevision,
      expected_edit_revision: expectedEditRevision, decision }),
  });
}

export function publishProfileInterestDraft(environment, { expectedPublishedRevision, reviewedRevision, actionId }) {
  return requestCatalog(environment, '/publish', {
    method: 'POST',
    body: JSON.stringify({ environment, action_id: actionId, expected_published_revision: expectedPublishedRevision,
      reviewed_revision: reviewedRevision }),
  });
}
